import React from "react";
import { Box, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import {
  colors,
  gradients,
  fontSize,
  fontWeight,
  padding,
  gaps,
  borderRadius,
} from "theme/defaultStyle";

const BarContainer = styled(Box)({
  display: "flex",
  alignItems: "flex-start",
  marginTop: gaps.medium1,
  marginBottom: gaps.medium1,
  marginRight: gaps.medium1,
  gap: gaps.small1,
  flexWrap: "wrap",
  background: gradients.blueGradient05,
  borderRadius: borderRadius.large,
  padding: `${padding.small1} ${padding.medium1}`,
});

const MetricItem = styled(Box)({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
  gap: gaps.xsmall1,
  padding: `${padding.small1} ${padding.xlarge}`,
  background: gradients.blueGradient03,
  borderRadius: borderRadius.large,
  flex: "0 0 auto",
});

const HighlightItem = styled(MetricItem)({
  background: gradients.blueGradient08,
});

const MetricLabel = styled(Typography)({
  fontSize: fontSize.xsmall,
  fontWeight: fontWeight.normal2,
  color: colors.blue17,
  whiteSpace: "nowrap",
  textTransform: "uppercase",
  letterSpacing: "0.06em",
});

const MetricValue = styled(Typography)({
  fontSize: fontSize.large,
  fontWeight: fontWeight.bold2,
  color: colors.white,
  whiteSpace: "nowrap",
});

export interface StatsBarMetric {
  label: string;
  value: string;
}

interface StatsBarProps {
  // Leading tile, rendered with the accent background (e.g. record count).
  highlight?: StatsBarMetric;
  metrics: StatsBarMetric[];
}

const StatsBar = ({ highlight, metrics }: StatsBarProps) => (
  <BarContainer>
    {highlight && (
      <HighlightItem>
        <MetricLabel>{highlight.label}</MetricLabel>
        <MetricValue>{highlight.value}</MetricValue>
      </HighlightItem>
    )}
    {metrics.map((metric) => (
      <MetricItem key={metric.label}>
        <MetricLabel>{metric.label}</MetricLabel>
        <MetricValue>{metric.value}</MetricValue>
      </MetricItem>
    ))}
  </BarContainer>
);

export default StatsBar;
